export const EXPERIMENTS = {
  COMPOSER_SETTINGS_REDESIGN: 'spec.forms.ComposerSettingsRedesign',
  COMPOSER_QUIZ_SETTINGS_REDESIGN: 'spec.forms.QuizSettingsRedesign',
  TARGET_SETTING: 'specs.forms.ComposerTargetSetting',
  MOVE_ECOM_LABEL_TRANSLATIONS: 'specs.forms.MoveEcomLabelTranslations',
  CLEAR_ON_AUTOFILL: 'specs.forms.ClearOnAutofill'
};
//# sourceMappingURL=experiments.js.map